import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { useI18n } from '@/i18n';

const SITE_URL = 'https://richyplay.live';
const SITE_LABEL = 'richyplay.live';

export function AuthSiteBar() {
  const { t } = useI18n();

  return (
    <div className="auth-page__bar">
      <a
        href={SITE_URL}
        className="auth-page__site"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('auth.visitSiteAria')}
      >
        <svg className="auth-page__site-arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M10 3L5 8l5 5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {SITE_LABEL}
      </a>
      <LanguageSelector drop="up" />
    </div>
  );
}
